import React from "react";

const SIZES = { sm: 24, md: 40, lg: 56 };

export const WriterLoader = ({ size = "md", message, className = "" }) => {
  const s = SIZES[size] || SIZES.md;
  return (
    <div className={`flex flex-col items-center gap-3 ${className}`} data-testid="writer-loader">
      <svg
        width={s} height={s} viewBox="0 0 48 48" fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Pen nib silhouette */}
        <path
          d="M24 4 L28 32 L24 44 L20 32 Z"
          fill="var(--ink-primary)"
          opacity="0.85"
        />
        <path
          d="M22 34 Q24 40 26 34"
          fill="var(--accent-gold)"
          className="writer-loader-drop"
        />
        {/* Ink trail */}
        <path
          d="M24 44 Q28 46 32 44"
          stroke="var(--accent-gold)"
          strokeWidth="1.5"
          fill="none"
          strokeDasharray="40"
          className="writer-loader-trail"
        />
      </svg>
      {message && (
        <p className="text-sm italic text-[var(--ink-secondary)] writer-loader-message font-[family-name:var(--font-serif-body)]">
          {message}
        </p>
      )}
    </div>
  );
};